export const topicData = [
  {
    value: "1",
    text: "버그",
    hex: "#4D455D",
  },
  {
    value: "2",
    text: "제안",
    hex: "#E96479",
  },
  {
    value: "3",
    text: "문의",
    hex: "#7DB9B6",
  },
];

export const categoryData = [
  {
    value: "01",
    text: "조직도",
  },
  {
    value: "02",
    text: "업무일지",
  },
  {
    value: "03",
    text: "교육이력",
  },
  {
    value: "04",
    text: "SOP",
  },
  {
    value: "05",
    text: "적응증별 임상시험정보",
  },
  {
    value: "06",
    text: "임상시험정보",
  },
  {
    value: "07",
    text: "임상시험현황",
  },
  {
    value: "08",
    text: "장비관리",
  },
  {
    value: "09",
    text: "Contract Registration",
  },
  {
    value: "10",
    text: "Project Assign",
  },
  {
    value: "11",
    text: "Monthly Report",
  },
  {
    value: "99",
    text: "Other",
  },
];

export const statusData = [
  {
    value: "1",
    text: "제출됨",
    hex: "#F2BE22",
    template: "statusHeaderFilter",
  },
  {
    value: "2",
    text: "진행중",
    hex: "#35baf6",
    template: "statusHeaderFilter",
  },
  {
    value: "3",
    text: "완료됨",
    hex: "#7FBA4C",
    template: "statusHeaderFilter",
  },
  {
    value: "4",
    text: "검토중",
    hex: "#D9D9D9",
    template: "statusHeaderFilter",
  },
];

export const template = {
  create: `<p><strong>## 다음 항목에 대해 작성해주세요</strong></p><p><br></p><ol><li>이슈가 발생한 화면을 캡쳐해주세요.<ul><li><br></li></ul></li><li>문제에 대해 설명해주세요.<ul><li><br></li></ul></li><li>예상했던 동작을 설명해주세요.<ul><li><br></li></ul></li></ol>`,
  view: ``,
  admin: ``,
};
